import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import socketIOClient from "socket.io-client";

import {
  agentsAction,
  queueStatsAction,
  queuesAction,
} from "../../../store/actions/rmq";
import { WEBSOCKET_URL } from "../../../config";

const useSocket = (user, dispatch) => {
  const token = useSelector(state => state.authReducer.token);

  const d = useDispatch();
  useEffect(() => {
    console.log("Connecting to websocket...");

    const socket = socketIOClient.connect(WEBSOCKET_URL, {
      extraHeaders: { Authorization: `Bearer ${token}` },
    });

    socket.emit("join", user);

    socket.on("agents", message => {
      // console.log(message);
      d(agentsAction(message));
    });

    socket.on("queue_stats", message => {
      // console.log(message);
      d(queueStatsAction(message));
    });

    socket.on("queues", message => {
      // console.log(message);
      d(queuesAction(message));
    });
    // }, [dispatch]);
  });
};

export default useSocket;
